module.exports = __webpack_public_path__ + "img/desain.ffcaf081.png";